/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import {useCallback} from 'react';
import {GenericObject} from '@ion/core/src/types/entities';

// Defines the props definitions for the Add / Update method
interface AddUpdateProps {
  layer: __esri.Feature;
  data: GenericObject[];
  selectedItem?: GenericObject;
  create: Function;
  addUpdate: Function;
};

/**
 * @useAddUpdateItems
 * React Hook to add/update items based on some callbacks
 *
 *  ```typescript
 *   import {useAddUpdateItems} from '@/routes/tracking/hooks';
 *
 *   const AddUpdateItems = useAddUpdateItems();
 *  ```
 */
export const useAddUpdateItems = () => {
  // Defines a utility to Add / Update items based on callbacks
  const addUpdateItems = useCallback(({
    layer,
    data,
    create,
    addUpdate,
    selectedItem
  }: AddUpdateProps) => {
    if (!layer) {
      if (data?.length) {
        create?.(data);
      }
    } else {
      addUpdate?.(data, selectedItem);
    }
  }, []);

  return addUpdateItems;
};
